export default __webpack_public_path__ + "static/media/split-leg.f8f7c5c7.png";